<button
  class="{{ shape + ' ' + display }}"
  type="{{ type }}"
  [attr.aria-label]="ariaLabel() || null"
  [disabled]="disabled"
  (click)="clickedButton.emit($event)"
>
  @if (icon && !asset) {
    <spa-icon [fontSize]="'24px'" shape="outlined">{{ icon }}</spa-icon>
  }
  @if (!icon && asset) {
    <div class="asset" [ngStyle]="{ 'background-image': 'url(assets/icon/' + asset + '.svg)' }"></div>
  }
  @if (label) {
    <div class="label">{{ label }}</div>
  }
</button>
